import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

const get = (url) => api.get(url).then((r) => r.data);

export const useVendorMe = (enabled = true) =>
  useQuery({ queryKey: ["vendor-me"], queryFn: () => get("/vendor/me"), enabled, retry: false });

export const useVendorDashboard = () =>
  useQuery({ queryKey: ["vendor-dashboard"], queryFn: () => get("/vendor/dashboard") });

export const useVendorProducts = (params = {}) =>
  useQuery({
    queryKey: ["vendor-products", params],
    queryFn: async () => {
      const q = params.q ? `?q=${encodeURIComponent(params.q)}` : "";
      const { data } = await api.get(`/vendor/products${q}`);
      return data;
    },
  });

export const useVendorFormations = () =>
  useQuery({ queryKey: ["vendor-formations"], queryFn: () => get("/vendor/formations") });

export const useVendorOrders = () =>
  useQuery({ queryKey: ["vendor-orders"], queryFn: () => get("/vendor/orders") });

export const useVendorClients = () =>
  useQuery({ queryKey: ["vendor-clients"], queryFn: () => get("/vendor/clients") });

export const useVendorSales = () =>
  useQuery({ queryKey: ["vendor-sales"], queryFn: () => get("/vendor/sales") });

export const useVendorSubscription = () =>
  useQuery({ queryKey: ["vendor-subscription"], queryFn: () => get("/vendor/subscription") });

export const useVendorPaymentMethods = () =>
  useQuery({ queryKey: ["vendor-payment-methods"], queryFn: () => get("/vendor/payment-methods") });

export const useVendorPaymentRequests = () =>
  useQuery({ queryKey: ["vendor-payment-requests"], queryFn: () => get("/vendor/payment-requests") });

export const useVendorActivities = () =>
  useQuery({ queryKey: ["vendor-activities"], queryFn: () => get("/vendor/activities") });

export const useVendorBadges = () =>
  useQuery({ queryKey: ["vendor-badges"], queryFn: () => get("/vendor/badges"), refetchInterval: 60000 });

export const useVendorLicenses = (params = {}) =>
  useQuery({ queryKey: ["vendor-licenses", params], queryFn: () => get("/vendor/licenses" + toQuery(params)) });

export const useVendorDeliveries = () =>
  useQuery({ queryKey: ["vendor-deliveries"], queryFn: () => get("/vendor/deliveries") });

export const useVendorPaymentsReview = (status = "review") =>
  useQuery({ queryKey: ["vendor-payments", status], queryFn: () => get(`/vendor/payments?status=${status}`) });

export const useVendorPaymentConfigs = () =>
  useQuery({ queryKey: ["vendor-payment-configs"], queryFn: () => get("/vendor/payment-configs") });

export const useVendorPromos = () =>
  useQuery({ queryKey: ["vendor-promos"], queryFn: () => get("/vendor/promo-codes") });

export const useVendorBundles = () =>
  useQuery({ queryKey: ["vendor-bundles"], queryFn: () => get("/vendor/bundles") });

export const useVendorBundleOptions = () =>
  useQuery({ queryKey: ["vendor-bundle-options"], queryFn: () => get("/vendor/bundle-options") });

export const useVendorPublications = () =>
  useQuery({ queryKey: ["vendor-publications"], queryFn: () => get("/vendor/publications") });

export const useVendorReviews = () =>
  useQuery({ queryKey: ["vendor-reviews"], queryFn: () => get("/vendor/reviews") });

export const useVendorStudents = (params = {}) =>
  useQuery({ queryKey: ["vendor-students", params], queryFn: () => get("/vendor/formation-students" + toQuery(params)) });

export const useVendorCertificates = () =>
  useQuery({ queryKey: ["vendor-certificates"], queryFn: () => get("/vendor/formation-certificates") });

export const useVendorInvoices = () =>
  useQuery({ queryKey: ["vendor-invoices"], queryFn: () => get("/vendor/invoices") });

function toQuery(params) {
  const q = Object.entries(params).filter(([, v]) => v !== "" && v != null)
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
  return q ? `?${q}` : "";
}

export function useVendorRefresh() {
  const qc = useQueryClient();
  return (keys) => (keys || [
    "vendor-me", "vendor-dashboard", "vendor-products", "vendor-formations", "vendor-orders",
    "vendor-clients", "vendor-sales", "vendor-subscription", "vendor-payment-methods",
    "vendor-payment-requests", "vendor-activities", "vendor-badges", "vendor-licenses",
    "vendor-deliveries", "vendor-payments", "vendor-payment-configs", "vendor-promos",
    "vendor-reviews", "vendor-students", "vendor-certificates", "vendor-invoices",
    "vendor-bundles", "vendor-bundle-options", "vendor-publications",
  ]).forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
}
